// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  BurnRequest as BurnRequest2Step,
  ExecutedBurn as ExecutedBurn2Step,
  RejectedBurn as RejectedBurns2Step,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { RequestState, RequestType, RowNew } from '../components/Table/types';
import TemplateContract from './TemplateContract';

export type BurnTemplateUnion =
  | TemplateContract<BurnRequest2Step>
  | TemplateContract<ExecutedBurn2Step>
  | TemplateContract<RejectedBurns2Step>;

const burnMapper = (
  contract: BurnTemplateUnion,
  requestType: RequestType,
  requestState: RequestState,
): RowNew => {
  const commonFields = {
    contractId: contract.contractId,
    createdAt: contract.createdAt,
    amount: contract.payload.burn.amount,
    holder: contract.payload.burn.holder,
    reference: contract.payload.burn.reference,
    sender: contract.payload.burn.holder,
    requestType,
    requestState,
    templateId: contract.templateId,
  };
  const flattened: RowNew = {
    ...commonFields,
    receiver: '',
    reason: '',
    operator: '',
    provider: '',
    instrumentId: '',
    registrar: '',
  };

  flattened.operator = contract.payload.operator;
  flattened.provider = contract.payload.provider;

  if ('reason' in contract.payload) {
    flattened.reason = contract.payload.reason;
  }

  flattened.instrumentId = contract.payload.burn.instrumentId.id;
  flattened.registrar = contract.payload.burn.instrumentId.admin;
  flattened.receiver = contract.payload.burn.instrumentId.admin;

  return flattened;
};

export const flattenBurns = (contracts: BurnTemplateUnion[], requestState: RequestState) => {
  return contracts.map((c) => burnMapper(c, RequestType.Burn, requestState));
};
